import i18n from '@/i18n';
import GTMComparisonTool from '@/utils/Controllers/GTM/Operations/ComparisonTool';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';

// Listing Filters
import { ListingProvider } from '@/context/listing';
import ListingController from '@/delonghi/Controllers/Listing';
import ListingFiltersApp from '@/listing-delonghi/ListingFiltersApp';

// Compare
import DELCompareInitiator from '@/delonghi/Controllers/Compare/DELCompareInitiator';
import { initPlpBVZeroReviews } from '@/utils/Controllers/Bazaarvoice/BVZeroReviewsController';

document.addEventListener('DOMContentLoaded', () => {
  // Listing Filters APP
  i18n.loadNamespaces('listing', () => {
    const FilterApp = () => (
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div />}>
          <ListingProvider>
            <ListingFiltersApp />
          </ListingProvider>
        </Suspense>
      </I18nextProvider>
    );
    const filtersEntry = document.getElementById(
      'js-r-entry-del-listing-filters',
    );

    ReactDOM.render(<FilterApp />, filtersEntry);
  });

  // Controllers
  ListingController();
  DELCompareInitiator();
  GTMComparisonTool();
  initPlpBVZeroReviews();
});
